import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMapMarkerComponent } from './user-map-marker.component';
import { SvgIconModule } from '../svg-icon';

@NgModule({
    declarations: [UserMapMarkerComponent],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [UserMapMarkerComponent]
})
export class UserMapMarkerModule { }
